export default __webpack_public_path__ + "static/interior-1026451_1920-ffced3bc3e1eb00e879b456246bce49c.png";